import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './views/home/home.component';
import { AudioGenerationComponent } from './views/audio-generation/audio-generation.component';
import { VideoGenerationComponent } from './views/video-generation/video-generation.component';
import { LoginComponent } from './views/login/login.component';
import { ChangePasswordComponent } from './views/change-password/change-password.component';
import { authGuard } from './services/auth/auth.guard';

const routes: Routes = [
    { path: '', redirectTo: 'login', pathMatch: 'full' }, // Redirect root to Home
    { path: 'home', component: HomeComponent, canActivate: [authGuard] },
    { path: 'audio', component: AudioGenerationComponent, canActivate: [authGuard] },
    { path: 'video', component: VideoGenerationComponent, canActivate: [authGuard] },
    { path: 'login', component: LoginComponent},
    { path: 'reset-password', component:ChangePasswordComponent, canActivate: [authGuard]},
    {
      path: 'vigi',
      loadChildren: () =>
        import('./views/vigi/vigi.module').then((m) => m.VigiModule),
      canActivate: [authGuard]
    },
  
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
